import ContactUsList from './List'
import ContactUsShow from './Show'

const ContactUsResource = {
  list: ContactUsList,
  show: ContactUsShow,
}

export default ContactUsResource
